module.exports = __webpack_public_path__ + "static/brand05-798230e81f1c57cb1c57d40ae2c245e4.png";